import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateGksSummaryReport } from '../../../services/report/ReportService';

class GksSummaryReport extends SpecificationReportPage {

  getFields() {
    return ['graveyard', 'graveField', 'period'];
  }

  getService() {
    return generateGksSummaryReport;
  }

  getFileName() {
    return "2B-gks-broj-1";
  }

  getPageTitle() {
    return strings.specificationReports.gksSummaryTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(GksSummaryReport)));
